<div *ngIf="bin_file==true">
  <h3>Downloading Report.........</h3>
</div>
<div class="report_nav" *ngIf="bin_file==false">
  <img class="report_arrow" [hidden]="index==0" (click)="navBarPrev('report_1')"
    src="assets/images/arrowleft.png" />
  <img class="report_arrow" [hidden]="index==banks.length-1" (click)="navBarNext('report_1')" src="assets/images/arrowright.png"
  />
  <b class="report">Jump to File: </b>
  <select *ngIf="what_if != ''" class="report_select" (change)="navBarChange($event.target.value, 'report_1')">
    <option *ngFor="let r of banks" [ngValue]="r" [selected]="r === report">{{r}}</option>
  </select>
  <select *ngIf="instr!='undefined' && what_if != 'true'" class="report_select" (change)="navBarChange($event.target.value, 'report_1')">
    <option *ngFor="let r of banks" [ngValue]="r" [selected]="r === report">{{r}}</option>
  </select>
  <select *ngIf="instr=='undefined' && what_if != 'true'" class="report_select" (change)="navBarChange($event.target.value, 'report_1')">
    <option *ngFor="let i of banks" [ngValue]="i" [selected]="i=== report">{{i}}</option>
  </select>
  <b class="team" [hidden]="(stud=='student' || start=='undefined' || instr=='undefined' || what_if=='true')">Team Select:</b>
  <select class="report_select" [hidden]="(stud=='student' || start=='undefined' || instr=='undefined' || what_if=='true')" (change)="navBarChange($event.target.value, 'team_1')">
    <option *ngFor="let t of teams" [ngValue]="t" [selected]="t === team">{{t}}</option>
  </select>
  <img class="team_arrow" [hidden]="(stud=='student' || t_index==0 || stud=='student' ||  start=='undefined' || instr=='undefined' || what_if=='true')"
    (click)="navBarPrev('team_1')" src="assets/images/arrowleft.png" />
  <img class="team_arrow" [hidden]="(stud=='student' || start=='undefined' || t_index==teams.length-1 || instr=='undefined' || what_if=='true')"
    (click)="navBarNext('team_1')" src="assets/images/arrowright.png" />
  <button class="report_close" (click)="navBarClose()">Close</button>
</div>
<pre class='pre_content'>
  <div class="report_data" *ngIf="report.endsWith('C95-Economic Charts') == false">
      {{report_data}}
  </div>
  <div class="report_data" *ngIf="report.endsWith('C95-Economic Charts') ==  true">
    <table>
      <thead>
      </thead>
      <tbody>
      <tr>
        <td><h1 style='font-size:20px; height:20px; margin-bottom: -50px; float:left; margin-left:40px;'>C95 --  Economic Charts, as of {{date1}}</h1></td>
        <td><h1 style='font-size:20px; height:20px; margin-bottom: -50px; float:right;'>{{date2}} {{community}}</h1></td>
      </tr>
      <tr>
      <td> <img [src]="svg_graph1 | safeHtml" /></td>
      <td> <img [src]="svg_graph2 | safeHtml" /></td>
      </tr>
      <tr>
      <td> <img [src]="svg_graph3 | safeHtml" /></td>
      <td> <img [src]="svg_graph4 | safeHtml" /></td>
      </tr>
     </tbody>
    </table>
   <p style= 'margin-left:20%;margin-top:-60px;'>  Economic  charts  as  of   {{date2}}   === C95 ===  </p> <span *ngIf="report.endsWith('C95-Economic Charts') == true" class="c_page_ins">Page {{index+1}}</span>
  </div>
</pre>
<div class='report_footer' *ngIf="report.endsWith('C95-Economic Charts') == false">{{foooter}} </div><span class="page" *ngIf="report.endsWith('C95-Economic Charts') == false">Page {{index+1}}</span>
